(ns nosco.ui.radio
  (:require
   [hx.react :refer [defnc]]
   [nosco.util :as util]
   [nosco.react]
   [nosco.hooks]
   [nosco.ui.text :as text]
   [react :as React]))

(defnc Radio [{:keys [name id label error container-props wrap-label? variant submitted] :as props}]
  (let [id (or id (nosco.hooks/use-id name))
        props (dissoc props :id :label :container-props :error :wrap-label? :variant :submitted)
        radio-input-ref (React/useRef)]
    (util/use-scale-in-out radio-input-ref submitted)
    [:label (nosco.react/merge-props
             {:class ["nosco-radio-with-label"
                      (when wrap-label? "wrap-label")
                      (when (= variant :large)
                        "nosco-radio-with-label--variant-large")]}
             container-props)
     [:input (->
              {:class ["nosco-radio__input"
                       (when error "nosco-radio__input--error")
                       (when submitted "nosco-radio__input--submitted")]
               :data-form-field-interactive true
               :type "radio"
               :id id
               :ref radio-input-ref}
              (nosco.react/merge-props props))]
     (when label
       [:<>
        [:span {:style {:display "inline-block"
                      ;padding as opposed to margin so pointer events don't pass through
                        :padding-left "8px"}}]
        [text/Text {:variant text/Body-Md-Regular
                    :class ["nosco-radio-with-label__label-text"
                            (if (:disabled props)
                              "text-neutral-300"
                              "text-neutral-900")]}

         label]])]))
